import React from "react";
import "../index.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
function NotFound() {
  return (
    <div
      className="center col gradient-01"
      style={{
        paddingBottom: "40%",
      }}
    >
      <h1
        style={{
          fontSize: "700%",
        }}
      >
        Ooops!
      </h1>
      <h2
        style={{
          fontSize: "250%",
        }}
      >
        404- PAGE NOT FOUND
      </h2>
      <p>
        The page you are looking for might have been removed or had its name
        changed or is temporaliy unavailable.
      </p>
      <a
        href="/"
        style={{
          textAlign: "center",
          maxWidth: "100%",
        }}
      >
        <Button
          style={{ width: "15%", justifyContent: "center", color: "white" }}
          variant="contained"
        >
          GO TO HOMEPAGE
        </Button>
      </a>
    </div>
  );
}

export default NotFound;
